import { EventService } from "./event-service.js";
import { getPublicUrl } from '../components/utils.js';

export default class LikeService extends EventService {
	constructor() {
		super();

		this.init();
	}

	init() {
		const self = this;
		if (document.querySelector('body .wrapper .reviews')) {
			document.querySelector('body .wrapper .reviews').addEventListener('click', function(event) {
				if (event.target.closest('.review .review-actions > a.btn-review-like')) {
					self.eventCallback(event);
				}
			});
		}
	}

	/** @deprecated */
	getHash() {
		return window.authService.retrieveHash();
	}

	/** @deprecated */
	getSavedLikes() {
		const likes = JSON.parse(localStorage.getItem("ti-likes")) || {};
		return likes;
	}

	/** @deprecated */
	isLikeExists(id, isLiked) {
		const hash = this.getHash();
		const likes = this.getSavedLikes();
		return likes[hash] && likes[hash][id] === isLiked;
	}

	/** @deprecated */
	saveLike(id, isLiked) {
		const hash = this.getHash();
		const likes = this.getSavedLikes();
		likes[hash] = likes[hash] || {};
		likes[hash][id] = isLiked;
		localStorage.setItem("ti-likes", JSON.stringify(likes));
	}

	process(container, link) {
		const reviewId = parseInt(link.closest('.review').dataset.id);
		const isLiked = link.classList.contains('btn-review-like') ? 1 : 0;
		const originalLikes = link.querySelector('span')
			? Number(link.querySelector('span').textContent.replace(/[^\d]/g, "").trim())
			: 0;

		// if (this.isLikeExists(reviewId, isLiked)) {
		// 	container.classList.remove('loading');
		// 	return;
		// }

		reCaptchaService.runWithCaptcha(
			"company_review_like",
			(token, withCheckbox = false) => {
				return axios.post(`${getPublicUrl()}/api/review/like`, {
					id: reviewId,
					is_liked: isLiked,
					recaptcha_token: token,
					recaptcha_checkbox: withCheckbox
				})
				.then((response) => {
					console.log("company_review_like", response);
					container.classList.remove('loading');

					if (response.data.success) {
						this.updateCounters(container, response.data.likes);
						this.saveLike(reviewId, isLiked);

						this.trigger('review-liked', {
							reviewId: reviewId,
                            originalLikes: originalLikes,
                            newLikes: response.data.likes,
							change: response.data.likes - originalLikes
						});
					}
				})
				.catch((msg) => {
					console.error("company_review_like", msg);
					container.classList.remove('loading');
				});
			}
		);
	}

	updateCounters(container, likes) {
		container.setIconCounter(likes, '(', ')');
	}

	eventCallback(event) {
		event.preventDefault();
		const link = event.target;
		link.blur();

		const container = link.closest('.btn-review-like');
		container.classList.add('loading');

		if (window.authService.checkAuth()) {
			this.process(container, link);
		} else {
			window.authService.showDialog();
			window.authService.on('closed', () => {
				this.process(container, link);
				container.classList.remove('loading');
			});
		}
	}
}